<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="医生详情"></pt-page-title>
    <pt-sub-title title="医生信息"></pt-sub-title>
    <template>
      <div :class="$style['pt-product-contract-detail']">
        <table>
          <tr>
            <td>姓名：</td>
            <td>{{detail.name}}</td>
          </tr>
          <tr v-if="userFullName">
            <td>商城用户：</td>
            <td>{{userFullName}}</td>
          </tr>
          <tr>
            <td>科室：</td>
            <td>{{detail.department}}</td>
          </tr>
          <tr>
            <td>职位：</td>
            <td>{{detail.position?detail.position:'--'}}</td>
          </tr>
          <tr>
            <td>执业医院：</td>
            <td>
              <div :class="$style['specification-table-div']" class="page-background">
                <table :class="$style['specification-table']">
                  <th>
                  <td>医院名称</td>
                  <td>分/子公司 </td>
                  <td>地区</td>
                  </th>
                  <tr v-for="(item,index) in detail.hospital" :key="index">
                    <td>{{item.name}}</td>
                    <td>{{item.branchName}} </td>
                    <td>{{item.address}}</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td>创建时间：</td>
            <td>{{detail.created_date ? detail.created_date :'--'}}</td>
          </tr>
          <tr>
            <td>身份证号：</td>
            <td>{{detail.idCard ? detail.idCard :'无'}}</td>
          </tr>
          <tr>
            <td>所属分/子公司：</td>
            <td>{{ detail.branchCompanyName ||'--'}}</td>
          </tr>
          <tr>
            <td>所属省份：</td>
            <td>{{(detail.addressDetails&&detail.addressDetails.provinceName)? detail.addressDetails.provinceName :'--'}}</td>
          </tr>
          <tr>
            <td>所属市：</td>
            <td>{{(detail.addressDetails&&detail.addressDetails.cityName) ? detail.addressDetails.cityName :'--'}}</td>
          </tr>
          <tr>
            <td>手机号：</td>
            <td>{{detail.mobile ? detail.mobile :'无'}}</td>
          </tr>
        </table>
      </div>
        <obs-department-message :data="questionMessage" v-if="questionMessage.joinObstetricsQA"></obs-department-message>
    </template>
    <div :class="$style['button-div']">
    <el-button type="primary" @click="goEdit(detail.id)" v-if="HAS_PERM_DOCTOR_OPERATION">编辑</el-button>
    <el-button type="primary" @click="tocheackInfo" v-if="userId">查看用户信息</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
import { hasPermissions } from 'utils/permissions'
import obsDepartmentMessage from './obs-department-message'
const prefixCls = 'pt-doctor-detail'
const PERM_DOCTOR_OPERATION = 'PERM_DOCTOR_OPERATION'// 所有分子公司的增删权限
const PERM_REGION_DOCTOR_OPERATION = 'PERM_REGION_DOCTOR_OPERATION'// 自己所属分子公司的增删权限
export default {
  name: 'pt-doctor-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    HAS_PERM_DOCTOR_OPERATION () {
      return (this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_DOCTOR_OPERATION)) ||
      (this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_REGION_DOCTOR_OPERATION))
    },
    questionMessage () {
      let { joinObstetricsQA, excellent, introduction, qaExtendInfo, idPhoto, qaHospitals	} = this.detail
      return { joinObstetricsQA, excellent, introduction, qaExtendInfo, idPhoto, qaHospitals }
    }
  },
  components: {
    obsDepartmentMessage
  },
  data () {
    return {
      productDetail: {},
      agentProduct: {},
      loading: false
    }
  },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    userId: {
      type: String,
      default: ''
    },
    userFullName: {
      type: String,
      default: ''
    }
  },
  methods: {
    goEdit (id) {
      this.$router.push('/doctor-manage/doctor-form/true/' + id)
    },
    tocheackInfo () {
      this.$router.push('/all-customer/customer-detail/' + this.userId + '?state=basic-message')
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  @import "~less/var.less";

  .wrap {
    padding: 50px 20px
  }

  .line {
    height: .45rem;
    line-height: .4rem;
    font-size: 16px
  }

  .name {
    text-align: end;
    color: @mainColor;
  }

  .title {
    padding-right: 1rem;
    font-size: .35rem !important;
  }

  .goods-table-div {
    margin-top: 10px;
    padding: 10px 20px 30px;
  }

  // .specification-table {
  //   display: table !important;
  //   width: 100% !important;
  //   border-collapse: collapse !important;

  //   th,
  //   tr {
  //     width: 100% !important;
  //     max-width: 100% !important;
  //     display: table-row;
  //     padding: 0 !important;
  //     list-style-type: none;
  //     border-bottom: 1px solid #C6C9D3;
  //     color: #818181
  //   }

  //   td {
  //     text-align: center;
  //     padding: 10px;
  //   }
  // }
  :global {
    .pt-product-contract-detail {
      color: #585558;
      .el-checkbox+.el-checkbox {
        margin-left: 0
      }

      .wt-box {
        justify-content: flex-start;
        margin-left: -1rem
      }

      .wt-box__item {
        margin-right: .5rem
      }
    }

  }

  .specification-table-div {
    margin-top:20px;
    padding: 0 .2rem .2rem;
  }

  .specification-table {
    display: table !important;
    border-collapse: collapse !important;

    th,
    tr {
      width: 100% !important;
      max-width: 100% !important;
      display: table-row !important;
      padding: 0 !important;
      list-style-type: none;
      justify-content: center !important;
      border-bottom: 1px solid #C6C9D3;
      color: #5B5B5B !important;
    }

    td {
      color: #5B5B5B !important;
      text-align: center;
      justify-content: flex-start !important;
      padding: 10px;
    }
  }

  .pt-product-contract-detail {
    padding: 0 20px;
    display: flex;
    flex-direction: row;

    :global table {
      tr {
        td {
          line-height: 40px;
          font-size: 16px;
        }

        :first-child {
          // width: 2rem;
          display: -webkit-box;
          color: @mainColor;
          justify-content: flex-end;
        }
        :last-child{
          color: #5B5B5B !important;
        }
      }
    }

    .el-checkbox+.el-checkbox {
      margin: 0
    }
  }
.button-div{
  margin-top: 20px;
}
</style>
